
/* Retailers extension */
var retailers = (function () {
    "use strict";
    return {
        mapCanvas: null,
        geocoder: null, 
        map: null,
        markers: [],
        sortedMarkers: [],
        directionsService: null, 
        directionDisplay: null,
        googleinitialized: false,
        initialized: false,
        resultDiv: null,
        routeInfoDiv: null,
        addressInput: null,
        nameDiv: null,
        imagePath: 'images',
        findNear: null,
        showRoomMarker: null,
        noShowRoomMarker: null,
        clustered: false,
        showRouteButton: false,
        defaultZoom: 11,
        initialZoom: 5,
        initialPositionLatitude: 63.113077,
        initialPositionLongitude: 16.6372206,
        showRetailerTypeFilter: false,
        searchCountry: 'sverige',
        country: 'se',
        

        updateResultCallback: function () {},

        initialize_exjs: function () {
            this.googleinitialized = true;
            this.initialize();

            if (window.location.hash.length > 0) {
                this.addressInput.value = decodeURIComponent(window.location.hash.substring(1));
                this.codeAddress();
            }

            if (this.addressInput.value.length > 0) {
                this.codeAddress();
            }


        },
        getQueryVariable: function(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (pair[0] == variable) {
                    return true;
                }
            }
            return false;
        },

        closeAllWindows: function () {
            var i;

            for (i = 0; i < this.markers.length; i++) {
              
                if (this.markers[i].hasOwnProperty("infowindow")) {
                    this.markers[i].infowindow.close();
                }
                
            }  
        },

        clearAllMarkers: function () {
            var i;

            for (i = 0; i < this.markers.length; i++) {
              
                if (this.markers[i].gMarker !== undefined) {
 
                    this.markers[i].gMarker.setMap(null);                   
                }
                
            }  
        },


        filterMarkersByType: function (markers) {

            var i,
                hptype1 = $("#retailerType1:checked").val() === "on",
                hptype2 = $("#retailerType2:checked").val() === "on",
                hptype3 = $("#retailerType3:checked").val() === "on",
                filteredMarkers = [];


            if (this.showRetailerTypeFilter) {

                for (i = 0; i < markers.length; i++) {

                    if (
                        (markers[i].hptype1 === 1 && hptype1) || 
                        (markers[i].hptype2 === 1 && hptype2) || 
                        (markers[i].hptype3 === 1 && hptype3)
                    ) {
                        filteredMarkers.push(markers[i]);
                    }

                }

                this.showMarkersByFilter();

            } else {
                return markers;
            }

            return filteredMarkers;

        },

        showMarkersByFilter: function () {

            var i,
                hptype1 = $("#retailerType1:checked").val() === "on",
                hptype2 = $("#retailerType2:checked").val() === "on",
                hptype3 = $("#retailerType3:checked").val() === "on";

             for (i = 0; i < this.markers.length; i++) {
              
                if (this.markers[i].gMarker !== undefined) {
                     
                    if (
                        (this.markers[i].hptype1 === 1 && hptype1) || 
                        (this.markers[i].hptype2 === 1 && hptype2) || 
                        (this.markers[i].hptype3 === 1 && hptype3)
                    ) {
                        this.markers[i].gMarker.setMap(this.map);
                    } else {
                        this.markers[i].gMarker.setMap(null);
                    }
                    
                }
                
                
            }  
        },

        createMarker: function (marker) {


            var thisPointer = this,
                markerImage = this.noShowRoomMarker,
                showRoomMarkerImage = {
                  url: this.showRoomMarker,
                  /*origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(32/2, 32 * 1.3),*/
                  scaledSize: new google.maps.Size(50, 50)
                },

                noAfMarkerImage = {
                  url: markerImage, /*
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(32/2, 32 * 1.3),*/
                  scaledSize: new google.maps.Size(32, 32)
                },
                markerData = {
                    title: marker.name
                };


            function createMarkerContent (marker) {

                var logoContent = '<a target="_blank" href="//www.thermia.se/kontakt-support/hitta-aterforsaljare/thermia-vaermepumpcenter/"></a>',
                    contactBtn = '<a class="button map_popup_contact_btn" target="_blank" href="' + marker.retailerUrl + '">' + findRetailerData.lang.contactUs + '</a>',
                    markerContent = '<div class="marker-content">';

                if (marker.retailerUrl !== undefined && marker.retailerUrl !== "") {
                    markerContent +=
                    '<div class="header">' +
                        '<a target="_blank" style="color:black;" href="' + marker.retailerUrl + '"">' +
                            '<b>' + marker.name + '</b>' + 
                        '</a>'+
                    '</div>';
             
                } else {
                    markerContent += '<b>' + marker.name + '</b><br/>';
                }

                var partnerLogo = "";

                if (thisPointer.country === 'nb' && marker.description === 'INSTALLER') {
                    partnerLogo = '<img class="center-logo-marker" src="/images/retailer/Thermia-partner_NO_badge_partnersearch.svg" alt="Thermia Partner" title="Thermia Partner">';
                }

                if (thisPointer.country === 'sv' && marker.type === 'TKG') {
                    partnerLogo = '<img alt="Hos ett Thermia Värmepumpcenter hittar du ett komplett utbud gällande Thermias villavärmepumpar – allt kring produkter, installation och service." title="Hos ett Thermia Värmepumpcenter hittar du ett komplett utbud gällande Thermias villavärmepumpar – allt kring produkter, installation och service." class="center-logo-marker" src="' + thisPointer.imagePath + '/Thermia-VPC_Karta.png">';
                }

                markerContent +=
                    '<div class="content">' +
                    '<div>' +
                        '<div>' + marker.address + '</div>' +
                        '<div>' + marker.zip + " " + marker.ort + '</div>' + 
                        contactBtn +
                    '</div>' +
                    '<div>' +
                        logoContent +
                        partnerLogo +
                    '</div>' +
                    '</div>';
                        

                //markerContent += marker.phone;
                /*
                if (marker.type === 'TKG') {
                    markerContent += '<div class="logo text-right">' + logoContent + '</div>';
                }
                */

                markerContent += '</div>';
                
                return markerContent;
            }


            function addPopupHandler (marker) {

                google.maps.event.addListener(marker.gMarker, 'click', function() {

                    thisPointer.closeAllWindows();

                    marker.infowindow.open(thisPointer.map, marker.gMarker);              
                });
            }


            if (!marker.hasOwnProperty('error') &&
                marker.lat !== "" &&
                marker.lat !== 0 && 
                marker.lng !== "" &&
                marker.lng !== 0) {
                
                
                marker.latlng = new google.maps.LatLng(marker.lat, marker.lng);
                markerData.position = marker.latlng;

                if (this.country === 'nb' ) {
                   
                    if (marker.description === 'INSTALLER') {
                        markerImage = "/images/retailer/Pin_Thermia_Partner_partnersearch.svg";
                    } else if (marker.description === 'SERVICE_PARTNER') {
                        markerImage = "/images/retailer/marker_yellow_small.png";
                    } else if (marker.description === 'RETAILER') {
                        markerImage = "/images/retailer/marker_gray_small.png";
                    } else if (marker.description === 'WHOLESALE') {
                        markerImage = "/images/retailer/marker_blue_small.png";
                    }
                    
                    markerData.icon = {
                        url: markerImage,
                        scaledSize: marker.description === 'INSTALLER' ? new google.maps.Size(36, 36) : new google.maps.Size(28, 28)
                    };

                } else if ( this.country === 'da' ) {

                    markerImage = "/images/retailer/marker_red_small.png";

                    markerData.icon = {
                        url: markerImage,
                        scaledSize: new google.maps.Size(32, 32)
                    };  

                } else {

                    if (marker.type === "TKG") {
                        markerData.icon = showRoomMarkerImage;
                    }
                    else {
                        markerData.icon = noAfMarkerImage;              
                    }

                }


                marker.gMarker = new google.maps.Marker(markerData);
                marker.infowindow = new google.maps.InfoWindow({

                });

                marker.infowindow.setContent(createMarkerContent(marker));

                addPopupHandler(marker);


                if (!this.clustered) {
                    marker.gMarker.setMap(this.map);
                }

            
            }
            else {
                marker.latlng = null;
            }

            return marker;


        },
        hasGeolocation: function (callback) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function () {
                        callback(true);
                    },function () {
                        callback(false);
                    }
                );
            } else {
                callback(false);
            }

        },
        findMyPosition: function () {
            var thisPointer = this;
            if (navigator.geolocation) {

                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        var latlng = new google.maps.LatLng(position.coords.latitude,position.coords.longitude);
                        thisPointer.renderResultsNearPosition(latlng);
                    }, 
                    function(args) {
                        /* No support, or could not found location */
                        alert(args.message);
                    }
                );
            }

        },

        resetMap: function () {
            var centerOfMap = new google.maps.LatLng(this.initialPositionLatitude, this.initialPositionLongitude);

            this.map.setCenter(centerOfMap);
            this.map.setZoom(this.initialZoom);
        },

        initialize: function() {           
            if (this.googleinitialized === false) {
                return;
            }


            var thisPointer = this,
                index,
                styledMap = new google.maps.StyledMapType(
                    [{
                        featureType: "poi",
                        stylers: [{ 
                            visibility: "off" 
                        }]   
                    }], 
                    {
                        name: "Styled Map"
                    }
                ),
                mapOptions = {
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControlOptions: {
                        mapTypeIds: [] /* google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID */
                    },
                    streetViewControl: false
                },
                markers = [];


            this.hasGeolocation(function (geoSupport) {

                if (geoSupport) {
                    $(".find-box").addClass("has-geolocation");
                }

            })
            

            this.directionsService = new google.maps.DirectionsService();
            this.directionsDisplay = new google.maps.DirectionsRenderer();
            
            this.map = new google.maps.Map(this.mapCanvas, mapOptions);
            this.directionsDisplay.setMap(this.map);

            this.map.mapTypes.set('map_style', styledMap);
            this.map.setMapTypeId('map_style');


            this.resetMap();

            var autoCompleteCountry = ['AX','SE'];


            if (this.country === "fi") {
                autoCompleteCountry = ['FI'];
                this.searchCountry = "Finland";
            } else if (this.country === "nb") {
                this.searchCountry = "Norge";
                autoCompleteCountry = ['NO'];
            } else if(this.country === "da") {
                this.searchCountry = "Danmark";
                autoCompleteCountry = ['DK'];
            }

            var autocomplete = new google.maps.places.Autocomplete(
                this.addressInput, 
                {
                    componentRestrictions: {
                        country: autoCompleteCountry
                    }
                }
            );

            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    //window.alert("No details available for input: '" + place.name + "'");
                    //return;
                } else {
                    thisPointer.map.setCenter(place.geometry.location);
                    //console.log('place', place);

                }
            });



            autocomplete.bindTo('bounds', this.map);

            for (index in this.markers) {
                markers.push(this.createMarker(this.markers[index]).gMarker);
            }

            $(".find-box").show();
            $(".find-box").removeClass("cookieconsent-optin-preferences cookieconsent-optin-statistics cookieconsent-optin-marketing");
            $(".cookieconsent").hide();

            if (this.clustered) {
                var mc = new MarkerClusterer(
                    this.map, 
                    markers,
                    {
                        gridSize: 50, 
                        maxZoom: 15
                        /*
                        ,styles: [{
                            url: this.noShowRoomMarker,
                            width: 42,
                            height: 37,
                            anchor: [0, 0],
                            iconAnchor: [42, 16],
                            textColor: '#ff0000',
                            textSize: 10
                        }]
                        */

                    }
                );
            }
            
        },  
        searchName: function () {

            var thisPointer = this,
                name = this.nameDiv.value,
                i,
                marker, 
                foundMarkers = [],
                resultContent = $('<div>');
            
            history.pushState("", document.title, window.location.pathname);


            for (i = 0; i <  thisPointer.markers.length; i++) {
                        
                marker = thisPointer.markers[i];
                marker.distance = -1;
                if (marker.name.search(new RegExp(name, "i")) !== -1)  {
                    foundMarkers.push(marker);
                }
            }

            foundMarkers = thisPointer.filterMarkersByType(foundMarkers);

            thisPointer.sortedMarkers = foundMarkers;

            for (i = 0; i < foundMarkers.length; i++) {
              
                marker = foundMarkers[i];
                    
                resultContent.append(thisPointer.getHtmlFromMarker(marker, i));                    
                
            }
                    
            thisPointer.updateResultDiv(resultContent, thisPointer.sortedMarkers);

        },
        updateResultDiv: function (content, markers) {

            var resultContainer = $(this.resultDiv),
                searchBoxHeight = $(".search-box").outerHeight();


            resultContainer.empty();
            resultContainer.append(content);

            resultContainer.css({"top": searchBoxHeight});

            this.updateResultCallback(markers);
        },
        getHtmlFromMarkers: function (markers, markerIndexes) {


            var marker,
                markerIndex,
                markerGroups = markers,
                thisPointer = this,
                i, 
                j,
                markerGroup,
                resultContent = $("<div>");
                    
            for(i = 0; i < markerGroups.length; i++) {
                markerGroup = markerGroups[i];
                
                resultContent.append($('<div class="showHeader">' + markerGroup.title + '</div>'));
                    
                for(j = 0; j < markerGroup.markers.length; j++) {
                    marker = markerGroup.markers[j];

                    markerIndex = markerIndexes[markerGroup.title + j];
                    
                    
                    resultContent.append(thisPointer.getHtmlFromMarker(marker, markerIndex));
                    
                }
            }
            return resultContent;

        },

        getHtmlFromMarker: function (marker, markerIndex) {
            var resultContent = $('<div class="search-entry">'),
                thisPointer = this,
                showOnMapFunction = function () {
                    retailers.showOnMap(markerIndex);
                },
                showRouteFunction = function () {
                     retailers.showRoute(markerIndex);
                },
                trackOpen = function () {
                    //_gaq.push(['_trackEvent', 'af-sida', 'open-site', "'" + marker.name + "'"]);
                },
                left = $('<div class="left columns small-8">'),
                right = $('<div class="right columns small-4 text-right">'),
                bottom = $('<div class="bottom row collapse">');


            if (marker.retailerUrl !== undefined && marker.retailerUrl !== "") {
                    left.append($('<a target="_blank" href="' + marker.retailerUrl + '"><b>' + marker.name + '</b></a>').click(function () {
                        trackOpen();
                    }));
                 
            } else {
                left.append('<div><b>' + marker.name + '</b></div>');
            }

            left.append("<div>" + 
                    marker.address + '<br/>' +
                    marker.zip + ' ' + marker.ort + 
                    '</div>');

/*
            left.append('<div>Tel: <a href="tel:'+marker.phone+'" class="phoneNumber">' + marker.phone + '</a></div>');
*/
            

            
            if (marker.distance !== -1) {
                right.append('<div class="distance"><span class="icomoon-two-way-arrow"></span> '+ thisPointer.formatDistance(marker.distance)+'</div>');
            }

            // Add partner logo
            if (marker['description'] === 'INSTALLER' && this.country === 'nb') {
                right.append('<img class="partner_logo" src="/images/retailer/Thermia-partner_NO_badge_partnersearch.svg" />');
            }


            if (marker.type === 'TKG') {
                right.append('<a target="_blank" href="//www.thermia.se/kontakt-support/hitta-aterforsaljare/thermia-vaermepumpcenter/"><img alt="Hos ett Thermia Värmepumpcenter hittar du ett komplett utbud gällande Thermias villavärmepumpar – allt kring produkter, installation och service." title="Hos ett Thermia Värmepumpcenter hittar du ett komplett utbud gällande Thermias villavärmepumpar – allt kring produkter, installation och service." class="center-logo" src="' + this.imagePath + '/Thermia-VPC_Karta.png"></a>');
            }


            if (this.showRouteButton) {
                bottom.append($('<a class="button">Vägbeskrivning</a>').click(function () {
                    showRouteFunction();
                }));
            }
            
            if (marker.retailerUrl !== undefined && marker.retailerUrl !== "") {
			    

                $('<div class="columns small-6">').append(
                    $('<a class="button" target="_blank" href="' + marker.retailerUrl + '">' + findRetailerData.lang.contactUs + '</a>').click(function () {
                        trackOpen();
                    })
                ).appendTo(bottom);
            }


            $('<div class="columns small-6 text-right">').append(
                    $('<a class="button">' + findRetailerData.lang.showOnMap + '</a>').click(function () {
                        showOnMapFunction();
                    })
                ).appendTo(bottom);


       
            $('<div class="row collapse top">').append(left).append(right).appendTo(resultContent);
            bottom.appendTo(resultContent);
        

            return $(resultContent);

        },
        codeAddress: function() {
            
            var input = this.addressInput.value,
                address = input + ", " + this.searchCountry,
                thisPointer = this;


            if (input === "") {
                this.resetMap();
                this.showMarkersByFilter();

                thisPointer.updateResultDiv("", []);
                return;
            }


            thisPointer.geocoder = new google.maps.Geocoder();
               
            this.geocoder.geocode({
                address: address
            }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  
                    window.location.hash = input;

                    thisPointer.renderResultsNearPosition(results[0].geometry.location);
                    
                }
                else {
                  //alert("Error: " + status);
                  alert("Kunde inte hitta den angivna platsen");
                }
            });
        },


        renderResultsNearPosition: function (latlng) {

            var thisPointer = this,
                i,
                marker,
                markersByGroup = {
                    has_campaign: {
                        title: '', // Återförsäljare med kampanj
                        markers: []                        
                    },
                    has_showroom: {
                        title: '', // Återförsäljare med shoowrooms
                        markers: []
                    },
                    other: {
                        title: '', // Har ej showroom
                        markers: []
                    }
                },
                markerGroup,
                markerGroups = [
                    markersByGroup.has_campaign
                ],
                markerIndexes =  {};
            

            thisPointer.findNear = latlng;
            
            thisPointer.map.setCenter(thisPointer.findNear);
            thisPointer.map.setZoom(thisPointer.defaultZoom);

            for (i = 0; i <  thisPointer.markers.length; i++) {
                
                marker = thisPointer.markers[i];
                
                
                
                if(marker.latlng != null) {
                    var distance = google.maps.geometry.spherical.computeDistanceBetween(thisPointer.findNear, marker.latlng);
                    marker.distance = distance;
                    marker.gMarker.setVisible(true);
                }
                else {
                    marker.distance = null;
                }
            }

            // Sort to distance
            thisPointer.markers.sort(thisPointer.sortByDistance);
            

            // Copy the nearest 15, this is a global variable all opther methods works with, so lets keep it intact, and workaround the index problems later
            thisPointer.sortedMarkers = this.filterMarkersByType(thisPointer.markers).slice(0, 15);
            
            if (!thisPointer.getQueryVariable('campaign')) {
                markerGroups.push(markersByGroup.has_showroom);
                markerGroups.push(markersByGroup.other);
            }
            
         
            for(i = 0; i < thisPointer.sortedMarkers.length; i++) {
                marker = thisPointer.sortedMarkers[i];
                if(marker.has_campaign) {
                    markerGroup = markersByGroup.has_campaign;
                } else if (marker.showroom) {
                    markerGroup = markersByGroup.has_showroom;
                } else {
                    markerGroup = markersByGroup.other;
                }
                markerIndexes[markerGroup.title + markerGroup.markers.length] = i;
                markerGroup.markers.push(marker);
            }
            

            var resultContent = thisPointer.getHtmlFromMarkers(markerGroups, markerIndexes);
                  

            thisPointer.updateResultDiv(resultContent, thisPointer.sortedMarkers);


        },

        showNumber: function(obj, i) {
            
            var marker = this.sortedMarkers[i];
          
            obj.nextSibling.style.display = 'inline';
            obj.style.display = 'none';
            

            return false;
        },
        showRoute: function(i) {
         
            var marker = this.sortedMarkers[i],
                latlng = new google.maps.LatLng(marker.lat, marker.lng),
                thisPointer = this;


            var request = {
                origin: thisPointer.findNear,
                destination: latlng,
                travelMode: google.maps.DirectionsTravelMode['DRIVING']
            };
            
            this.directionsService.route(request, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    thisPointer.directionsDisplay.setDirections(response);
                    thisPointer.showSteps(response, marker);
                }
            });
            
            return true;
        },
        showSteps: function(directionResult, marker) {
            var myRoute = directionResult.routes[0].legs[0],
                routeInfo = $("<div class='routeInfo'>");
                    
            routeInfo.append('<h2>Vägbeskrivning</h2>');

            routeInfo.append(
                '<div class="goalInfo">' +
                    '<b>' + marker.name + '</b></br>' +
                    marker.address + '</br>' +
                    marker.zip + '</br>' +
                    marker.phone + '</br></br>' +
                '</div>');
        
            
            for (var i = 0; i < myRoute.steps.length; i++) {            
                routeInfo.append('<p>' + (i + 1) + '. ' + myRoute.steps[i].instructions + '</p>');
            }
            
            routeInfo.append('<input class="button" type="button" value="Skriv ut" onclick="window.print();" />');
            
            $(this.routeInfoDiv).empty().append(routeInfo);
        },        
        attachInstructionText: function(marker, text) {
            google.maps.event.addListener(marker, 'click', function() {
                stepDisplay.setContent(text);
                stepDisplay.open(this.map, marker);
            });
        },
        showOnMap: function(i) {
            var marker = this.sortedMarkers[i],
                thisPointer = this;


            this.closeAllWindows();

            marker.infowindow.open(this.map, marker.gMarker);


            this.map.setZoom(thisPointer.defaultZoom);        
            this.map.setCenter(marker.latlng);
        },
        formatDistance: function(distance) {
            if(false && distance > 10000) {
                return Math.round(distance / 100) / 100 + ' mil';
            }
            else {
                return Math.round(distance / 100) / 10 + ' km';
            }
        },
        sortByDistance: function(a, b) {
            if(a.distance == null) {
                return 1;
            }
            if(b.distance == null) {
                return -1;
            }
            
            if (a.distance > b.distance) {
                return 1;
            }
            else if (a.distance == b.distance) {
                return 0;
            }
            else {
                return -1;
            }
        },
        sortByShowroom: function (a, b) {
            
            if (a.hasOwnProperty('retailerUrl') != b.hasOwnProperty('retailerUrl')) {
                if (a.hasOwnProperty('retailerUrl')) {
                    return -1;
                }
                return 1;
                
            }
            
            if(a.showroom == b.showroom) {
                return sortByDistance(a, b);
            }
            
            if (a.showroom) {
                return -1;
            }
             return 1;
            
        },
        prepareMarkerFromTKG: function (markers) {
            var i,
                virtualPhone,
                getCustomField = function (marker, key) {

                    if (marker.customFields.hasOwnProperty(key)) {
                        return marker.customFields[key][0].value;
                    }

                    return null;
                }
            
            for (i = 0; i < markers.length; i++) {

                virtualPhone = getCustomField(markers[i], "virtualPhone");
                markers[i].lat = getCustomField(markers[i], "latitude");
                markers[i].lng = getCustomField(markers[i], "longitude");

                markers[i].hptype1 = (getCustomField(markers[i], "pumptyp1") === "1" ? 1 : 0);
                markers[i].hptype2 = (getCustomField(markers[i], "pumptyp2") === "1" ? 1 : 0);
                markers[i].hptype3 = (getCustomField(markers[i], "pumptyp3") === "1" ? 1 : 0);


                markers[i].address = getCustomField(markers[i], "address");
                markers[i].phone = getCustomField(markers[i], "phone");
                if (virtualPhone !== null) {
                    markers[i].phone = virtualPhone;
                }

                markers[i].zip = getCustomField(markers[i], "post_zip");
                
                markers[i].ort = getCustomField(markers[i], "ort");

                markers[i].retailerUrl = markers[i].url;
                

            }

            return markers;

        },
        init: function (args) {
            var thisPointer = this;

            if (args.mapCanvas === null) {
                return;
            }

            this.clearAllMarkers();

            this.markers = this.prepareMarkerFromTKG(args.markers);
            this.mapCanvas = args.mapCanvas;
            this.resultDiv = args.resultDiv;
            this.routeInfoDiv = args.routeInfoDiv;
            this.addressInput = args.addressInput;
            this.nameDiv = args.nameDiv;
            this.imagePath = args.imagePath;
            this.showRoomMarker = args.showRoomMarker;
            this.noShowRoomMarker = args.noShowRoomMarker;

            if (args.updateResultCallback) {
                this.updateResultCallback = args.updateResultCallback;
            }

            
            if (args.initialPositionLatitude) {
                this.initialPositionLatitude = args.initialPositionLatitude;
            }
            if (args.initialPositionLongitude) {
                this.initialPositionLongitude = args.initialPositionLongitude;
            }
            if (args.initialZoom) {
                this.initialZoom = args.initialZoom;
            }
            if (args.showRetailerTypeFilter) {
                this.showRetailerTypeFilter = args.showRetailerTypeFilter;
            }

            if (args.searchCountry) {
                this.searchCountry = args.searchCountry;
            }
            if (args.country) {
                this.country = args.country;
            }
            

            if (this.googleinitialized) {
                this.initialize_exjs();
           } else {
                const exernalScriptCountry = this.country;
                const loadExternalScript = function() {
                    $.getScript(
                        'https://maps.googleapis.com/maps/api/js?key=AIzaSyDRopXKRTnjjnZyykjWyYTFtLOwHOuLhZ8&v=3.29&libraries=geometry,places&language=' + exernalScriptCountry + '&' + 'callback=retailers.initialize_exjs',
                        function (data, textStatus, jqxhr) { }
                    );
                };

                if (Cookiebot.consent.marketing) {
                    loadExternalScript();
                } else {
                    window.addEventListener('CookiebotOnConsentReady', function() {
                        if (!Cookiebot.consent.marketing) { return; }

                        loadExternalScript();
                    });
                }
            }
        }

    };

}());